import { useMutation } from '@tanstack/react-query';

import { BusinessPlanFilesApi } from '../businessPlanFiles.api';

export const useBusinessPlanFileDelete = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  return useMutation({
    mutationFn: BusinessPlanFilesApi.deleteFile,
    onSuccess,
  });
};
